import React from "react"

import { Trans, useBounceGlobalValues, useTranslation } from "@bounce/i18n"

import { Banner } from "./Banner"
import { useUrl } from "@/libs/router"
import { useAppURL } from "@/utils/appURL"

import illo from "./assets/packages.png"

export type PackagesProps = {
  showImage?: boolean
  className?: string
}

export const Packages = ({ showImage, className }: PackagesProps) => {
  const { t } = useTranslation("marketing-generic")
  const bounceGlobals = useBounceGlobalValues()

  const buildAppURL = useAppURL()
  const { getUrl } = useUrl()
  const url = buildAppURL(getUrl({ path: "/packages/location" }))
  const image = showImage ? illo : undefined

  const onClick = () => location.assign(url)

  return (
    <Banner
      image={image}
      title={t("cmp.packagesBanner.title", "Never miss a delivery with Bounce Package Acceptance")}
      subtitle={t(
        "cmp.packagesBanner.subtitle",
        "Receive your package to a safe location & pickup at a convenient time for you.",
      )}
      ctaSubtitle={
        <Trans
          ns="marketing-generic"
          i18nKey="cmp.packagesBanner.price"
          defaults="Send your package to a safe place for just <bold>{{ pricePerDay }}/package</bold>."
          values={{ pricePerDay: bounceGlobals.pricePerPackageDecimal }}
          components={{ bold: <strong /> }}
        />
      }
      ctaLabel={t("cmp.packagesBanner.cta", "Find your package pickup ")}
      ctaOnClick={onClick}
      className={className}
    />
  )
}
